<footer class="footer ">
  <div class="container-fluid">
    <nav class="pull-left">
      <ul>
       
        <li>
          <a href="https://www.yahoo.com">
            Footer Links here
          </a>
        </li>
        <li>
          <a href="https://www.yahoo.com">
            Footer Links here
          </a>
        </li>
        <li>
          <a href="https://www.yahoo.com">
            Footer Links here
          </a>
        </li>
         
      </ul>
    </nav>
    <div class="copyright pull-right">
      &copy;
      {{test | date: 'yyyy'}}, made with <i class="material-icons">favorite</i>  
    </div>
  </div>
</footer>
